var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQualityofServiceQoSTesting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FE8839;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250,194c39.7,0,72-32.3,72-72s-32.3-72-72-72s-72,32.3-72,72S210.3,194,250,194z M250,66 c30.9,0,56,25.1,56,56s-25.1,56-56,56s-56-25.1-56-56S219.1,66,250,66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250,162c22.1,0,40-17.9,40-40s-17.9-40-40-40s-40,17.9-40,40S227.9,162,250,162z M250,98 c13.2,0,24,10.8,24,24s-10.8,24-24,24s-24-10.8-24-24S236.8,98,250,98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M482,418V170c0-22.1-17.9-40-40-40h-72V91.7l-22.4-5.5c-1-2.7-2.1-5.3-3.3-8l11.9-19.7l-42.8-42.8l-19.7,11.9 c-2.6-1.2-5.3-2.3-8-3.3L280.3,2h-60.5l-5.5,22.4c-2.7,1-5.3,2.1-8,3.3l-19.7-11.9l-42.8,42.8l11.9,19.7c-1.2,2.6-2.3,5.3-3.3,8 L130,91.7V130H58c-22.1,0-40,17.9-40,40v248H2v40c0,22.1,17.9,40,40,40h416c22.1,0,40-17.9,40-40v-40H482z M146,104.3l18.8-4.6 l1.4-4.3c1.5-4.6,3.4-9.2,5.8-13.8l2.1-4l-10-16.6L189,35.9l16.6,10l4-2.1c4.6-2.4,9.2-4.3,13.8-5.8l4.3-1.4l4.6-18.8h35.5 l4.6,18.8l4.3,1.4c4.6,1.4,9.2,3.4,13.8,5.8l4,2.1l16.6-10L336.1,61l-10,16.6l2.1,4c2.4,4.6,4.3,9.2,5.8,13.8l1.4,4.3l18.8,4.6 v35.5l-18.8,4.6l-1.4,4.3c-1.5,4.6-3.4,9.2-5.8,13.8l-2.1,4l10,16.6L311,208.1l-16.6-10l-4,2.1c-4.6,2.4-9.2,4.3-13.8,5.8 l-4.3,1.4l-4.6,18.8h-35.5l-4.6-18.8l-4.3-1.4c-4.6-1.5-9.2-3.4-13.8-5.8l-4-2.1l-16.6,10L163.9,183l10-16.6l-2.1-4 c-2.4-4.6-4.3-9.2-5.8-13.8l-1.4-4.3l-18.8-4.6L146,104.3z M186.6,228.3l19.7-11.9c2.6,1.2,5.3,2.3,8,3.3l5.5,22.4h60.5l5.5-22.4 c2.7-1,5.3-2.1,8-3.3l19.7,11.9l42.8-42.8l-4.5-7.4H434v208H66V178h82.2l-4.5,7.5L186.6,228.3z M34,170c0-13.2,10.8-24,24-24h72 v6.3l22.4,5.5c0.5,1.4,1.2,2.8,1.8,4.2H66c-8.8,0-16,7.2-16,16v208c0,8.8,7.2,16,16,16h368c8.8,0,16-7.2,16-16V178 c0-8.8-7.2-16-16-16h-88.1c0.6-1.4,1.2-2.8,1.8-4.2l22.4-5.5V146h72c13.2,0,24,10.8,24,24v248H34V170z M482,458 c0,13.2-10.8,24-24,24H42c-13.2,0-24-10.8-24-24v-24h464V458z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34,450h16v16H34V450z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66,450h16v16H66V450z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98,450h16v16H98V450z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98,306c0,35.3,28.7,64,64,64s64-28.7,64-64c0-9.5-2.1-18.5-5.9-26.6l18.9-15.1l-10-12.5l-17.4,13.9 C199.9,251.2,182,242,162,242C126.7,242,98,270.7,98,306L98,306z M162,258c15,0,28.3,6.9,37.1,17.6l-44.6,35.6l-18.9-18.9 l-11.3,11.3l29.1,29.1l53.7-43c1.8,5.1,2.9,10.5,2.9,16.2c0,26.5-21.5,48-48,48s-48-21.5-48-48S135.5,258,162,258L162,258z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M338,370c35.3,0,64-28.7,64-64s-28.7-64-64-64s-64,28.7-64,64S302.7,370,338,370z M338,258 c26.5,0,48,21.5,48,48s-21.5,48-48,48s-48-21.5-48-48S311.5,258,338,258z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M319.7,335.7l18.3-18.3l18.3,18.3l11.3-11.3L349.3,306l18.3-18.3l-11.3-11.3L338,294.7l-18.3-18.3l-11.3,11.3 l18.3,18.3l-18.3,18.3L319.7,335.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityofServiceQoSTesting);
export default __webpack_public_path__ + "static/media/Quality of Service (QoS) Testing.09e9dd36df367d07728d074cb5dc27d8.svg";
export { ForwardRef as ReactComponent };